import { Trans, useTranslation } from 'react-i18next';
import { useGetCompaniesQuery } from 'src/shared/api/company';
import { type Company } from 'src/shared/types/company';
import { InformationModal } from '../InformationModal';
import { ManualSteps } from './components/ManualSteps';
import { type CustomInformationModalProps } from 'src/modules/SaldoView/types';

export const ManualInformationModal = ({ closeModal, selectedCompanyId, account }: CustomInformationModalProps) => {
  const { t } = useTranslation('overview');
  const { data: companies } = useGetCompaniesQuery();
  const selectedCompanyData = companies?.data.find((company: Company) => company.id === selectedCompanyId);

  return (
    <InformationModal
      closeModal={closeModal}
      selectedCompanyId={selectedCompanyId}
      account={account}
      title={t('self funding.Recharge balance by transfer')}
      description={
        <Trans i18nKey={'self funding.Recharge balance description'} ns="overview" components={[<strong />]} />
      }
      initialValues={{
        companyName: selectedCompanyData?.name ?? '',
        IBAN: account?.accountNumber ?? '',
        beneficiaryName: selectedCompanyData?.name ?? ''
      }}
      StepsComponent={ManualSteps}
    />
  );
};
